/**
 * ERP 정적 메뉴 구성 (인사·기준·예산 등 대메뉴 공용 스키마)
 *
 * 화면(leaf) 필수 필드:
 * - screenId: 화면 고유값 (Ctrl+F 검색 / 즐겨찾기 키). 신규 화면 추가 시 반드시 부여.
 * - menuType: 'crud'(등록) | 'inquiry'(조회) | 'report'(출력)
 * - componentPath: pages/ 하위 경로 (PageComponents.js 동적 로드)
 *
 * 공통 UI 재사용: docs/COMMON_UI_FEATURES.md , .cursor/rules/erp-common-ui.mdc
 */
/** icon: ModuleMenuIcon 키 (접힘 사이드바 레일). iconSrc 있으면 이미지 우선 */
export const HR_TOP_MENUS = [
  { id: '100', label: '인사관리', icon: 'users', iconSrc: null, menuNo: '100', progId: 'HR' },
  { id: '200', label: '기준정보', icon: 'settings', iconSrc: null, menuNo: '200', progId: 'ADM' },
  { id: '300', label: '예산관리', icon: 'pieChart', iconSrc: null, menuNo: '300', progId: 'BUD' },
  { id: '400', label: '지출관리', icon: 'banknote', iconSrc: null, menuNo: '400', progId: 'EXP' },
  { id: '500', label: '수입관리', icon: 'moneyBag', iconSrc: null, menuNo: '500', progId: 'INC' },
  { id: '600', label: '계약관리', icon: 'clipboard', iconSrc: null, menuNo: '600', progId: 'CTR' },
];

/** 로그인 후 / 탭 전체 닫기 후 열리는 첫 화면 */
export const HR_HOME_TAB = {
  id: '110',
  label: '대시보드',
  path: '/hr/dashboard',
  component: 'HR_DASH',
  componentPath: 'pages/hr/HrDashboard',
  screenId: 'HR_DASH',
  menuType: 'inquiry',
};

export const HR_LEFT_MENUS = {
  '100': [
    {
      id: '100',
      label: '인사관리',
      menuNo: '100',
      upperMenuId: '0',
      url: 'dir',
      children: [
        {
          id: '110',
          label: '대시보드',
          menuNo: '110',
          upperMenuId: '100',
          progId: 'HR_DASH',
          screenId: 'HR_DASH',
          menuType: 'inquiry',
          url: '/hr/dashboard',
          componentPath: 'pages/hr/HrDashboard',
        },
        {
          id: '120',
          label: '발령 목록',
          menuNo: '120',
          upperMenuId: '100',
          progId: 'HR_APT_LIST',
          screenId: 'HR_APT_LIST',
          menuType: 'inquiry',
          url: '/hr/appointments',
          componentPath: 'pages/hr/AppointmentList',
        },
        {
          id: '125',
          label: '인사마스터',
          menuNo: '125',
          upperMenuId: '100',
          progId: 'HR_EMP_MASTER',
          screenId: 'HR_EMP_MASTER',
          menuType: 'crud',
          url: '/hr/employee-master',
          componentPath: 'pages/hr/EmployeeMasterList',
        },
        {
          id: '130',
          label: '인사카드',
          menuNo: '130',
          upperMenuId: '100',
          progId: 'HR_EMP_CARD',
          screenId: 'HR_EMP_CARD',
          menuType: 'inquiry',
          url: '/hr/employees',
          componentPath: 'pages/hr/EmployeeCard',
        },
      ],
    },
  ],
  '200': [
    {
      id: '200',
      label: '기준정보',
      menuNo: '200',
      upperMenuId: '0',
      url: 'dir',
      children: [
        {
          id: '201',
          label: '조직관리',
          menuNo: '201',
          upperMenuId: '200',
          url: 'dir',
          children: [
            {
              id: '205',
              label: '기관등록',
              menuNo: '205',
              upperMenuId: '201',
              progId: 'ADM_TENANT',
              screenId: 'ADM_TENANT',
              menuType: 'crud',
              url: '/system/tenant',
              componentPath: 'pages/system/TenantRegister',
              // 시스템 운영자(마스터) 전용 — 일반 기관 사용자 메뉴에서 숨김
              masterOnly: true,
            },
            {
              id: '215',
              label: '공통코드',
              menuNo: '215',
              upperMenuId: '201',
              progId: 'ADM_COMMON_CODE',
              screenId: 'ADM_COMMON_CODE',
              menuType: 'crud',
              url: '/system/common-code',
              componentPath: 'pages/system/CommonCodeManage',
              // 시스템 마스터 전용 — 전역 코드 레지스트리
              masterOnly: true,
            },
            {
              id: '214',
              label: '회계단위등록',
              menuNo: '214',
              upperMenuId: '201',
              progId: 'ADM_ACCT_UNIT',
              screenId: 'ADM_ACCT_UNIT',
              menuType: 'crud',
              url: '/master/acct-unit',
              componentPath: 'pages/budget/AcctUnitRegister',
              adminOnly: true,
            },
            {
              id: '210',
              label: '부서관리',
              menuNo: '210',
              upperMenuId: '201',
              progId: 'ADM_DEPT',
              screenId: 'ADM_DEPT',
              menuType: 'crud',
              url: '/master/dept',
              componentPath: 'pages/hr/DeptManage',
            },
            {
              id: '207',
              label: '사용자관리',
              menuNo: '207',
              upperMenuId: '201',
              progId: 'ADM_USER',
              screenId: 'ADM_USER',
              menuType: 'crud',
              url: '/system/users',
              componentPath: 'pages/system/UserManage',
              // 기관 관리자 전용 — 현재 JWT에서는 masterYn으로 판정
              adminOnly: true,
            },
            {
              id: '220',
              label: '규정 파라미터',
              menuNo: '220',
              upperMenuId: '201',
              progId: 'HR_PARAM',
              screenId: 'HR_PARAM',
              menuType: 'crud',
              url: '/hr/parameters',
              componentPath: 'pages/hr/ParameterList',
            },
          ],
        },
        {
          id: '250',
          label: '거래처',
          menuNo: '250',
          upperMenuId: '200',
          url: 'dir',
          children: [
            {
              id: '251',
              label: '거래처등록',
              menuNo: '251',
              upperMenuId: '250',
              progId: 'ADM_VENDOR',
              screenId: 'ADM_VENDOR',
              menuType: 'crud',
              url: '/master/vendor',
              componentPath: 'pages/master/VendorRegister',
            },
          ],
        },
        {
          id: '260',
          label: '기관금융',
          menuNo: '260',
          upperMenuId: '200',
          url: 'dir',
          children: [
            {
              id: '261',
              label: '기관계좌·카드',
              menuNo: '261',
              upperMenuId: '260',
              progId: 'ADM_ORG_FINANCE',
              screenId: 'ADM_ORG_FINANCE',
              menuType: 'crud',
              url: '/master/org-finance',
              componentPath: 'pages/master/OrgFinanceRegister',
            },
          ],
        },
        {
          id: '231',
          label: '환경설정',
          menuNo: '231',
          upperMenuId: '200',
          progId: 'ADM_ENV',
          screenId: 'ADM_ENV',
          menuType: 'crud',
          url: '/system/env-settings',
          componentPath: 'pages/system/EnvSettings',
          adminOnly: true,
        },
        {
          id: '206',
          label: '권한관리',
          menuNo: '206',
          upperMenuId: '200',
          url: 'dir',
          children: [
            {
              id: '208',
              label: '부서권한설정',
              menuNo: '208',
              upperMenuId: '206',
              progId: 'ADM_DEPT_PERM',
              screenId: 'ADM_DEPT_PERM',
              menuType: 'crud',
              url: '/system/dept-permission',
              componentPath: 'pages/system/DeptPermissionManage',
              // 일반 사용자의 기본권한은 부서×모듈 단위로 관리
              adminOnly: true,
            },
            {
              id: '209',
              label: '관리자권한설정',
              menuNo: '209',
              upperMenuId: '206',
              progId: 'ADM_ADMIN_PERM',
              screenId: 'ADM_ADMIN_PERM',
              menuType: 'crud',
              url: '/system/admin-permission',
              componentPath: 'pages/system/AdminPermissionManage',
              // 관리자 화면구성·권한구성 (예외는 별도 화면)
              adminOnly: true,
            },
            {
              id: '211',
              label: '예외권한설정',
              menuNo: '211',
              upperMenuId: '206',
              progId: 'ADM_EXCEPTION_PERM',
              screenId: 'ADM_EXCEPTION_PERM',
              menuType: 'crud',
              url: '/system/exception-permission',
              componentPath: 'pages/system/ExceptionPermissionManage',
              // 사용자×프로그램×버튼 예외
              adminOnly: true,
            },
          ],
        },
        {
          id: '240',
          label: '예산정보',
          menuNo: '240',
          upperMenuId: '200',
          url: 'dir',
          children: [
            {
              id: '212',
              label: '예산구분등록',
              menuNo: '212',
              upperMenuId: '240',
              progId: 'ADM_ACCT_CLASS',
              screenId: 'ADM_ACCT_CLASS',
              menuType: 'crud',
              url: '/master/acct-class',
              componentPath: 'pages/budget/AcctClassRegister',
              adminOnly: true,
            },
            {
              id: '330',
              label: '사업',
              menuNo: '330',
              upperMenuId: '240',
              url: 'dir',
              children: [
                {
                  id: '331',
                  label: '사업구조화관리',
                  menuNo: '331',
                  upperMenuId: '330',
                  progId: 'BUD_PROJ_STRUCT',
                  screenId: 'BUD_PROJ_STRUCT',
                  menuType: 'crud',
                  url: '/budget/project-structure',
                  componentPath: 'pages/budget/BudgetProjectStructure',
                },
                {
                  id: '332',
                  label: '사업등록',
                  menuNo: '332',
                  upperMenuId: '330',
                  progId: 'BUD_PROJ_REG',
                  screenId: 'BUD_PROJ_REG',
                  menuType: 'crud',
                  url: '/budget/project-register',
                  componentPath: 'pages/budget/BudgetProjectRegister',
                },
              ],
            },
            {
              id: '320',
              label: '예산과목',
              menuNo: '320',
              upperMenuId: '240',
              url: 'dir',
              children: [
                {
                  id: '321',
                  label: '예산과목구조관리',
                  menuNo: '321',
                  upperMenuId: '320',
                  progId: 'BUD_SUBJ_STRUCT',
                  screenId: 'BUD_SUBJ_STRUCT',
                  menuType: 'crud',
                  url: '/budget/subject-structure',
                  componentPath: 'pages/budget/BudgetSubjectStructure',
                },
                {
                  id: '322',
                  label: '예산과목등록',
                  menuNo: '322',
                  upperMenuId: '320',
                  progId: 'BUD_SUBJ_REG',
                  screenId: 'BUD_SUBJ_REG',
                  menuType: 'crud',
                  url: '/budget/subject-register',
                  componentPath: 'pages/budget/BudgetSubjectRegister',
                },
              ],
            },
            {
              id: '230',
              label: '재원',
              menuNo: '230',
              upperMenuId: '240',
              url: 'dir',
              children: [
                {
                  id: '232',
                  label: '재원등록',
                  menuNo: '232',
                  upperMenuId: '230',
                  progId: 'ADM_FUND',
                  screenId: 'ADM_FUND',
                  menuType: 'crud',
                  url: '/master/fund',
                  componentPath: 'pages/budget/BudgetFundRegister',
                },
                {
                  id: '233',
                  label: '재원구성등록',
                  menuNo: '233',
                  upperMenuId: '230',
                  progId: 'ADM_FUND_PKG',
                  screenId: 'ADM_FUND_PKG',
                  menuType: 'crud',
                  url: '/master/fund-package',
                  componentPath: 'pages/budget/BudgetFundPackageRegister',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  '300': [
    {
      id: '300',
      label: '예산관리',
      menuNo: '300',
      upperMenuId: '0',
      url: 'dir',
      children: [
        {
          id: '310',
          label: '대시보드',
          menuNo: '310',
          upperMenuId: '300',
          progId: 'BUD_DASH',
          screenId: 'BUD_DASH',
          menuType: 'inquiry',
          url: '/budget/dashboard',
          componentPath: 'pages/budget/BudgetDashboard',
        },
        {
          id: '311',
          label: '업무프로세스맵(샘플)',
          menuNo: '311',
          upperMenuId: '300',
          progId: 'BUD_PROC_MAP',
          screenId: 'BUD_PROC_MAP',
          menuType: 'inquiry',
          url: '/budget/process-map-sample',
          componentPath: 'pages/budget/ProcessMapSample',
        },
        {
          id: '320',
          label: '사업계획',
          menuNo: '320',
          upperMenuId: '300',
          url: 'dir',
          children: [
            {
              id: '321',
              label: '사업계획 양식관리',
              menuNo: '321',
              upperMenuId: '320',
              progId: 'BUD_BIZ_FORM',
              screenId: 'BUD_BIZ_FORM',
              menuType: 'crud',
              url: '/budget/biz-form-template',
              componentPath: 'pages/budget/BizFormTemplateManage',
            },
            {
              id: '322',
              label: '사업계획서 작성',
              menuNo: '322',
              upperMenuId: '320',
              progId: 'BUD_BIZ_PLAN',
              screenId: 'BUD_BIZ_PLAN',
              menuType: 'crud',
              url: '/budget/biz-plan-rhwp-poc',
              componentPath: 'pages/budget/BizPlanRhwpPoc',
            },
          ],
        },
        {
          id: '340',
          label: '예산편성',
          menuNo: '340',
          upperMenuId: '300',
          url: 'dir',
          children: [
            {
              id: '341',
              label: '예산차수등록',
              menuNo: '341',
              upperMenuId: '340',
              progId: 'BUD_ROUND_REG',
              screenId: 'BUD_ROUND_REG',
              menuType: 'crud',
              url: '/budget/round-register',
              componentPath: 'pages/budget/BudgetRoundRegister',
            },
            {
              id: '342',
              label: '지출예산편성요구',
              menuNo: '342',
              upperMenuId: '340',
              progId: 'BUD_EXP_REQ',
              screenId: 'BUD_EXP_REQ',
              menuType: 'crud',
              url: '/budget/expense-request',
              componentPath: 'pages/budget/BudgetExpenseRequest',
            },
            {
              id: '344',
              label: '지출예산편성조정',
              menuNo: '344',
              upperMenuId: '340',
              progId: 'BUD_EXP_ADJ',
              screenId: 'BUD_EXP_ADJ',
              menuType: 'crud',
              url: '/budget/expense-adjust',
              componentPath: 'pages/budget/BudgetExpenseAdjust',
            },
            {
              id: '345',
              label: '수입예산편성요구',
              menuNo: '345',
              upperMenuId: '340',
              progId: 'BUD_INC_REQ',
              screenId: 'BUD_INC_REQ',
              menuType: 'crud',
              url: '/budget/income-request',
              componentPath: 'pages/budget/BudgetIncomeRequest',
            },
            {
              id: '346',
              label: '수입예산편성조정',
              menuNo: '346',
              upperMenuId: '340',
              progId: 'BUD_INC_ADJ',
              screenId: 'BUD_INC_ADJ',
              menuType: 'crud',
              url: '/budget/income-adjust',
              componentPath: 'pages/budget/BudgetIncomeAdjust',
            },
            {
              id: '343',
              label: '편성내역조회',
              menuNo: '343',
              upperMenuId: '340',
              progId: 'BUD_REQ_INQUIRY',
              screenId: 'BUD_REQ_INQUIRY',
              menuType: 'inquiry',
              url: '/budget/request-inquiry',
              componentPath: 'pages/budget/BudgetRequestInquiry',
            },
            {
              id: '3432',
              label: '편성내역조회2',
              menuNo: '3432',
              upperMenuId: '340',
              progId: 'BUD_REQ_INQUIRY2',
              screenId: 'BUD_REQ_INQUIRY2',
              menuType: 'inquiry',
              url: '/budget/request-inquiry-2',
              componentPath: 'pages/budget/BudgetRequestInquiry2',
            },
            {
              id: '347',
              label: '현액관리',
              menuNo: '347',
              upperMenuId: '340',
              progId: 'BUD_BALANCE',
              screenId: 'BUD_BALANCE',
              menuType: 'inquiry',
              url: '/budget/balance',
              componentPath: 'pages/budget/BudgetBalance',
            },
          ],
        },
        {
          id: '350',
          label: '예산배정',
          menuNo: '350',
          upperMenuId: '300',
          url: 'dir',
          children: [
            {
              id: '351',
              label: '예산배정계획수립',
              menuNo: '351',
              upperMenuId: '350',
              progId: 'BUD_ALLOC_PLAN',
              screenId: 'BUD_ALLOC_PLAN',
              menuType: 'crud',
              url: '/budget/alloc-plan',
              componentPath: 'pages/budget/BudgetAllocPlan',
            },
            {
              id: '352',
              label: '예산배정처리',
              menuNo: '352',
              upperMenuId: '350',
              progId: 'BUD_ALLOC_PROCESS',
              screenId: 'BUD_ALLOC_PROCESS',
              menuType: 'crud',
              url: '/budget/alloc-process',
              componentPath: 'pages/budget/BudgetAllocProcess',
            },
            {
              id: '353',
              label: '예산배정승인',
              menuNo: '353',
              upperMenuId: '350',
              progId: 'BUD_ALLOC_APPROVE',
              screenId: 'BUD_ALLOC_APPROVE',
              menuType: 'crud',
              url: '/budget/alloc-approve',
              componentPath: 'pages/budget/BudgetAllocApprove',
            },
          ],
        },
        {
          id: '360',
          label: '예산변경',
          menuNo: '360',
          upperMenuId: '300',
          url: 'dir',
          children: [
            {
              id: '361',
              label: '예산변경등록',
              menuNo: '361',
              upperMenuId: '360',
              progId: 'BUD_CHANGE_REG',
              screenId: 'BUD_CHANGE_REG',
              menuType: 'crud',
              url: '/budget/change-register',
              componentPath: 'pages/budget/BudgetChangeRegister',
            },
            {
              id: '362',
              label: '예산변경승인',
              menuNo: '362',
              upperMenuId: '360',
              progId: 'BUD_CHANGE_APPROVE',
              screenId: 'BUD_CHANGE_APPROVE',
              menuType: 'crud',
              url: '/budget/change-approve',
              componentPath: 'pages/budget/BudgetChangeApprove',
            },
          ],
        },
      ],
    },
  ],
  '400': [
    {
      id: '400',
      label: '지출관리',
      menuNo: '400',
      upperMenuId: '0',
      url: 'dir',
      children: [
        {
          id: '410',
          label: '지출품의',
          menuNo: '410',
          upperMenuId: '400',
          url: 'dir',
          children: [
            {
              id: '411',
              label: '지출품의등록',
              menuNo: '411',
              upperMenuId: '410',
              progId: 'EXP_PROP_REG',
              screenId: 'EXP_PROP_REG',
              menuType: 'crud',
              url: '/expense/proposal-register',
              componentPath: 'pages/expense/ExpenseProposalRegister',
            },
            {
              id: '412',
              label: '지출품의승인',
              menuNo: '412',
              upperMenuId: '410',
              progId: 'EXP_PROP_APPROVE',
              screenId: 'EXP_PROP_APPROVE',
              menuType: 'crud',
              url: '/expense/proposal-approve',
              componentPath: 'pages/expense/ExpenseProposalApprove',
            },
            {
              id: '413',
              label: '계약의뢰등록',
              menuNo: '413',
              upperMenuId: '410',
              progId: 'EXP_CTR_REQ_REG',
              screenId: 'EXP_CTR_REQ_REG',
              menuType: 'crud',
              url: '/expense/contract-request-register',
              componentPath: 'pages/expense/ExpenseContractRequestRegister',
            },
          ],
        },
        {
          id: '420',
          label: '원인행위',
          menuNo: '420',
          upperMenuId: '400',
          url: 'dir',
          children: [
            {
              id: '421',
              label: '원인행위등록',
              menuNo: '421',
              upperMenuId: '420',
              progId: 'EXP_OBL_REG',
              screenId: 'EXP_OBL_REG',
              menuType: 'crud',
              url: '/expense/obligation-register',
              componentPath: 'pages/expense/ExpenseObligationRegister',
            },
            {
              id: '422',
              label: '원인행위승인',
              menuNo: '422',
              upperMenuId: '420',
              progId: 'EXP_OBL_APPROVE',
              screenId: 'EXP_OBL_APPROVE',
              menuType: 'crud',
              url: '/expense/obligation-approve',
              componentPath: 'pages/expense/ExpenseObligationApprove',
            },
          ],
        },
        {
          id: '430',
          label: '지출결의',
          menuNo: '430',
          upperMenuId: '400',
          url: 'dir',
          children: [
            {
              id: '431',
              label: '지출결의등록',
              menuNo: '431',
              upperMenuId: '430',
              progId: 'EXP_RES_REG',
              screenId: 'EXP_RES_REG',
              menuType: 'crud',
              url: '/expense/resolution-register',
              componentPath: 'pages/expense/ExpenseResolutionRegister',
            },
            {
              id: '4312',
              label: '지출결의등록2',
              menuNo: '4312',
              upperMenuId: '430',
              progId: 'EXP_RES_REG2',
              screenId: 'EXP_RES_REG2',
              menuType: 'crud',
              url: '/expense/resolution-register-2',
              componentPath: 'pages/expense/ExpenseResolutionRegister2',
            },
            {
              id: '4313',
              label: '지출결의등록(type1)',
              menuNo: '4313',
              upperMenuId: '430',
              progId: 'EXP_RES_REG_T1',
              screenId: 'EXP_RES_REG_T1',
              menuType: 'crud',
              url: '/expense/resolution-register-type1',
              componentPath: 'pages/expense/ExpenseResolutionRegisterType1',
            },
            {
              id: '4314',
              label: '지출결의등록(type2)',
              menuNo: '4314',
              upperMenuId: '430',
              progId: 'EXP_RES_REG_T2',
              screenId: 'EXP_RES_REG_T2',
              menuType: 'crud',
              url: '/expense/resolution-register-type2',
              componentPath: 'pages/expense/ExpenseResolutionRegisterType2',
            },
            {
              id: '432',
              label: '지출결의승인',
              menuNo: '432',
              upperMenuId: '430',
              progId: 'EXP_RES_APPROVE',
              screenId: 'EXP_RES_APPROVE',
              menuType: 'crud',
              url: '/expense/resolution-approve',
              componentPath: 'pages/expense/ExpenseResolutionApprove',
            },
          ],
        },
        {
          id: '440',
          label: '지급명령',
          menuNo: '440',
          upperMenuId: '400',
          url: 'dir',
          children: [
            {
              id: '441',
              label: '지급명령',
              menuNo: '441',
              upperMenuId: '440',
              progId: 'EXP_PAY_ORDER',
              screenId: 'EXP_PAY_ORDER',
              menuType: 'crud',
              url: '/expense/payment-order',
              componentPath: 'pages/expense/ExpensePaymentOrder',
            },
          ],
        },
      ],
    },
  ],
  '500': [
    {
      id: '500',
      label: '수입관리',
      menuNo: '500',
      upperMenuId: '0',
      url: 'dir',
      children: [
        {
          id: '510',
          label: '수입원천',
          menuNo: '510',
          upperMenuId: '500',
          url: 'dir',
          children: [
            {
              id: '511',
              label: '수입원천등록',
              menuNo: '511',
              upperMenuId: '510',
              progId: 'INC_SOURCE_REG',
              screenId: 'INC_SOURCE_REG',
              menuType: 'crud',
              url: '/income/source-register',
              componentPath: 'pages/income/IncomeSourceRegister',
            },
          ],
        },
        {
          id: '520',
          label: '수입결의',
          menuNo: '520',
          upperMenuId: '500',
          url: 'dir',
          children: [
            {
              id: '521',
              label: '수입결의등록',
              menuNo: '521',
              upperMenuId: '520',
              progId: 'INC_RES_REG',
              screenId: 'INC_RES_REG',
              menuType: 'crud',
              url: '/income/resolution-register',
              componentPath: 'pages/income/IncomeResolutionRegister',
            },
            {
              id: '522',
              label: '수입결의승인',
              menuNo: '522',
              upperMenuId: '520',
              progId: 'INC_RES_APPROVE',
              screenId: 'INC_RES_APPROVE',
              menuType: 'crud',
              url: '/income/resolution-approve',
              componentPath: 'pages/income/IncomeResolutionApprove',
            },
          ],
        },
        {
          id: '530',
          label: '수납결의',
          menuNo: '530',
          upperMenuId: '500',
          url: 'dir',
          children: [
            {
              id: '531',
              label: '수납결의등록',
              menuNo: '531',
              upperMenuId: '530',
              progId: 'INC_RCPT_REG',
              screenId: 'INC_RCPT_REG',
              menuType: 'crud',
              url: '/income/receipt-register',
              componentPath: 'pages/income/ReceiptResolutionRegister',
            },
            {
              id: '532',
              label: '수납결의승인',
              menuNo: '532',
              upperMenuId: '530',
              progId: 'INC_RCPT_APPROVE',
              screenId: 'INC_RCPT_APPROVE',
              menuType: 'crud',
              url: '/income/receipt-approve',
              componentPath: 'pages/income/ReceiptResolutionApprove',
            },
          ],
        },
        {
          id: '540',
          label: '조정결의',
          menuNo: '540',
          upperMenuId: '500',
          url: 'dir',
          children: [
            {
              id: '541',
              label: '조정결의',
              menuNo: '541',
              upperMenuId: '540',
              progId: 'INC_ADJUST',
              screenId: 'INC_ADJUST',
              menuType: 'crud',
              url: '/income/adjust',
              componentPath: 'pages/income/IncomeAdjustWorkspace',
            },
          ],
        },
        {
          id: '550',
          label: '과오납',
          menuNo: '550',
          upperMenuId: '500',
          url: 'dir',
          children: [
            {
              id: '551',
              label: '과오납처리',
              menuNo: '551',
              upperMenuId: '550',
              progId: 'INC_OVERPAY',
              screenId: 'INC_OVERPAY',
              menuType: 'crud',
              url: '/income/overpayment',
              componentPath: 'pages/income/IncomeOverpayment',
            },
          ],
        },
        {
          id: '560',
          label: '불납결손',
          menuNo: '560',
          upperMenuId: '500',
          url: 'dir',
          children: [
            {
              id: '561',
              label: '불납결손처리',
              menuNo: '561',
              upperMenuId: '560',
              progId: 'INC_WRITEOFF',
              screenId: 'INC_WRITEOFF',
              menuType: 'crud',
              url: '/income/uncollectible',
              componentPath: 'pages/income/IncomeUncollectible',
            },
          ],
        },
      ],
    },
  ],
  '600': [
    {
      id: '600',
      label: '계약관리',
      menuNo: '600',
      upperMenuId: '0',
      url: 'dir',
      children: [
        {
          id: '605',
          label: '계약의뢰',
          menuNo: '605',
          upperMenuId: '600',
          url: 'dir',
          children: [
            {
              id: '606',
              label: '계약의뢰접수',
              menuNo: '606',
              upperMenuId: '605',
              progId: 'CTR_REQ_RCV',
              screenId: 'CTR_REQ_RCV',
              menuType: 'crud',
              url: '/contract/request-receive',
              componentPath: 'pages/expense/ExpenseContractRequestReceive',
            },
          ],
        },
        {
          id: '610',
          label: '계약대장',
          menuNo: '610',
          upperMenuId: '600',
          url: 'dir',
          children: [
            {
              id: '611',
              label: '계약대장등록',
              menuNo: '611',
              upperMenuId: '610',
              progId: 'CTR_LEDGER_REG',
              screenId: 'CTR_LEDGER_REG',
              menuType: 'crud',
              url: '/contract/ledger-register',
              componentPath: 'pages/contract/ContractRegister',
            },
          ],
        },
      ],
    },
  ],
};

export const MENU_TYPE_LABEL = {
  crud: '등록',
  inquiry: '조회',
  report: '출력',
};

/**
 * 사용자 권한별 메뉴 필터
 * - masterOnly 화면은 시스템 마스터(masterYn=Y)에게만 노출
 * - 자식이 모두 숨겨진 디렉터리는 함께 숨김
 */
function filterMenuTree(items, { isMaster }) {
  return (items || [])
    .map((item) => {
      if (item.children?.length) {
        const children = filterMenuTree(item.children, { isMaster });
        if (!children.length) return null;
        return { ...item, children };
      }
      if ((item.masterOnly || item.adminOnly) && !isMaster) return null;
      return item;
    })
    .filter(Boolean);
}

export function filterLeftMenusForUser(leftMenus, { isMaster = false } = {}) {
  const result = {};
  Object.entries(leftMenus || {}).forEach(([topId, trees]) => {
    result[topId] = filterMenuTree(trees, { isMaster });
  });
  return result;
}
